var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.02 14.012H10c-.061 0-6.264-.012-7.83-.437A2.5 2.5 0 0 1 .408 11.81 26.493 26.493 0 0 1 0 7a26.645 26.645 0 0 1 .417-4.817A2.564 2.564 0 0 1 2.184.4C3.706 0 9.738 0 9.994 0h.02c.064 0 6.283.012 7.832.437.858.233 1.53.904 1.762 1.763a25.25 25.25 0 0 1 .407 4.831 26.568 26.568 0 0 1-.418 4.811 2.51 2.51 0 0 1-1.767 1.763c-1.52.403-7.553.407-7.81.407Zm-2-10.007-.004 6 5.212-3-5.207-3Z",
    fill: "#999"
  })));
};
export default SvgYoutube;